<template>
    <table
        id="kgr-files-table"
        class="kgr-table kgr-table--block"
    >
        <thead>
            <tr class="kgr-table__row">
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('filename') }}
                </th>
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('uploadedAt') }}
                </th>
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('updatedAt') }}
                </th>
                <th class="kgr-table__cell kgr-table__cell--headline">
                    {{ $t('description') }}
                </th>
                <th class="kgr-table__cell kgr-table__cell--headline kgr-table__cell--actions">
                    {{ $t('options') }}
                </th>
            </tr>
        </thead>
        <tbody>
            <kgr-file-table-relation
                v-for="(relation, index) in relations"
                :key="relation.id"
                :relation="relation"
                :active-nodes="activeNodes"
                :is-striped="index % 2 === 0"
                @addActive="addActive"
                @removeActive="removeActive"
            />
        </tbody>
    </table>
</template>

<script>
import FileTableRelation from './FileTableRelation.vue';

export default {
    components: {
        'kgr-file-table-relation': FileTableRelation,
    },
    props: {
        relations: {
            type: Array,
            required: true,
            default: () => {
                return [];
            },
        },
    },
    data() {
        return {
            activeNodes: [],
        };
    },
    methods: {
        addActive(id) {
            this.activeNodes.push(id);
        },
        removeActive(id) {
            const index = this.activeNodes.indexOf(id);
            if (index !== -1) {
                this.activeNodes.splice(index, 1);
            }
        },
    },
};
</script>
